<template>
	<div class="VipRight">
		<div class="PubBox Boxs   ZAuto">
			<div class="QuickNavigation">
				<div class="cone_left-title">
					<div class="title-sub">
						快捷导航
					</div>
				</div>
				<div class="flex-align-items">
					<div class="QuickNavigation-list">
						<a href="https://www.chuy1.com/" target="_blank"><img src="../../assets/images/nav_pic1.png" class="img">
						<p class="title">企业官网</p></a>
					</div>
					<!-- <div class="QuickNavigation-list">
						<a href="https://www.chuy1.com/" target="_blank"><img src="../../assets/images/nav_pic2.png" class="img">
						<p class="title">每日一练</p></a>
					</div>
					<div class="QuickNavigation-list">
						<a href="https://www.chuy1.com/" target="_blank"><img src="../../assets/images/nav_pic3.png" class="img">
						<p class="title">错题集</p></a>
					</div> -->
					<div class="QuickNavigation-list">
						<a href="https://www.chuy1.com/" target="_blank"><img src="../../assets/images/nav_pic4.png" class="img">
						<p class="title">我的收藏</p></a>
					</div>
					<div class="QuickNavigation-list">
						<a href="https://www.chuy1.com/" target="_blank"><img src="../../assets/images/nav_pic5.png" class="img">
						<p class="title">我的合同</p></a>
					</div>
					<div class="QuickNavigation-list">
						<a href="https://www.chuy1.com/" target="_blank"><img src="../../assets/images/nav_pic6.png" class="img">
						<p class="title">我的测评</p></a>
					</div>
				</div>
			</div>
			<div class="QuickNavigation">
				<div class="cone_left-title">
					<div class="title-sub">
						已购课程
					</div>
				</div>
				<div class="right-content">
					<div class="card-carousel-wrapper">
						<div class="card-carousel--nav__left" @click="moveCarousel(-1)" :disabled="atHeadOfList"></div>
						<div class="card-carousel">
							<div class="card-carousel--overflow-container">
								<div class="card-carousel-cards"
									:style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
									<div class="card-carousel--card" v-for="(item,index) in wdkclist">
										<div class="card-carousel--card--footer bg_q" @click="mykclist(index)">
											<p>{{ item.title }}</p>

										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="card-carousel--nav__right" @click="moveCarousel(1)" :disabled="atEndOfList"></div>
					</div>
				</div>
			 
				<div v-for="(item1,index1) in wdkclist" v-show="index1 == listshowid" >
					<div class="tabBody">
						
						<div :class="{tabItem:true,tabActiveItem:studytab2 == 0}" @click="studyzl(0)">
							课程学习
							<div class="cpage-tabitem-line" v-show="studytab2 == 0"></div>
						</div>
						<div :class="{tabItem:true,tabActiveItem:studytab2 == 1}" @click="studyzl(1)">
							课程资料
							<div class="cpage-tabitem-line" v-show="studytab2 == 1"></div>
						</div>
					</div>
					<div v-show="studytab2 == 0">
						<div class="nkclist">
							<el-row>
							  
							  <el-button size="small" round v-for="(item, index) in item1.child" :key="index" @click="changecid(item.cid)" >
							  {{ item.title }}
							  </el-button>
							  
							</el-row>
						</div>
						 
						 
						<div style="padding:30px 50px 0 50px">
							<kclist  :ucid="ncid" :alllist="alllist"></kclist>
						</div>
					</div>
					<div v-show="studytab2 == 1">
						<div class="nkclist">
							<el-row>
							  
							  <el-button size="small" round v-for="(item, index) in item1.child" :key="index" @click="changekjcid(item.cid)" >
							  {{ item.title }}
							  </el-button>
							  
							</el-row>
						</div>
						<div style="padding:30px 50px 0 50px">
							<kjlist  :ucid="ncid" :kckjlist="kckjlist"></kjlist>
						</div>
					</div>
				</div>
			</div>




		</div>


	</div>
</template>
<script>
	import {
		getCourseList,
		getCourseDetail,
		getQuestionByCid,
		getCourseWare,
		studyList,
		updateVideo,
		accessStatistical,
		updateRecord,
		getCourseRecordList
	} from "../../api/api";
	import Kclist from "./kc_list.vue";
	import Kjlist from "./tabkj.vue";
	export default {
		props: {
			bank: {
				type: Number,
				default: 0
			},

		},
		data() {
			return {
				studytab2:0,
				alllist:[],
				bankId: 0,
				 kckjlist:[],
				 kckjtitle:"",
				courseId:0,
				coursekjId:0,
				listshowid: 0,
				studytab1: 0,
				liststatus: false,
				studyTab: {},
				studyTabList: [],
				subjectList: [],
				catalogList: [],
				wdkclist: [],
				currentOffset: 0,
				windowSize: 3,
				paginationFactor: 220,
				 
				activeName: 'second'
			};
		},
		mounted() {
			 this.$nextTick(function () {
				 this.getulist()
				 this.getkjlist()
				this.getCourseSpecialType()
			})
		 
		}, computed: {
			ncid:function(){
				 return this.courseId
			},
			kjcid:function(){
				return this.coursekjId
			},
			atEndOfList() {
				return this.currentOffset <= (this.paginationFactor * -1) * (this.wdkclist.length - this.windowSize);
			},
			atHeadOfList() {
				return this.currentOffset === 0;
			},
			
 
		},
		methods: {
			studyzl(index){
				this.studytab2=index;
				console.log(this.studytab2);
			},
			mykclist(index) {
				this.listshowid = index
			},
			getkjlist() {
				getCourseWare({
					cid:this.kjcid
				})
				.then((res) => {
				 	if (res.code == 1) {
						
				 	 this.kckjlist=res.data.list;
				 		console.log("this.kckjlist");
				 		 console.log(this.kckjlist);	 
				 	} 
				
					})
			},
			changekjcid(kjid){
				this.coursekjId=kjid;
				getCourseWare({
					cid:kjid
				})
				.then((res) => {
				 	if (res.code == 1) {
						
				 	 this.kckjlist=res.data.list;
				 		console.log("this.kckjlist");
				 		 console.log(this.kckjlist);	 
				 	} 
				
					})
			},
			changecid(cid){
				this.courseId = cid;
				 getCourseDetail({
				 	cid: cid
				 }).then((res) => {
				 	if (res.code == 1) {
				 		 
				 		this.alllist=res.data.contents;
				 		console.log('getCourseDetail');
				 		console.log(this.alllist);
				 		 this.getData1()
				 		// _this.changeVideo(_this.currentSpecial.video_list[0]);
				 	 
				 			 
				 	} 
				 });
			},
			getulist(){
				getCourseList({})
					.then(res => {
						if (res.code == 1) {
							let listx = res.data.course_list;
							this.wdkclist = listx;
							console.log("这是wdkclist:")
							console.log(this.wdkclist)
							if(this.wdkclist.length>0){
								this.wdkclist.forEach((itme,index)=>{
								 
									if(index == 0){
										console.log('itm');
										console.log(itme.child);
										getCourseDetail({
											cid: itme.child[index].cid
										}).then((res) => {
											if (res.code == 1) {
												 
												this.alllist=res.data.contents;
												console.log('getCourseDetail');
												console.log(this.alllist);
												 this.getData1()
												// _this.changeVideo(_this.currentSpecial.video_list[0]);
											 
													 
											} 
										});
										getCourseWare({
											cid:itme.child[index].cid
										})
										.then((res) => {
										 	if (res.code == 1) {
												
										 	 this.kckjlist=res.data.list;
										 		console.log("this.kckjlist");
										 		 console.log(this.kckjlist);	 
										 	} 
										
											})
										let bkid=itme.child[index].cid;
										this.courseId=itme.child[index].cid ;
										this.coursekjId=itme.child[index].cid;
										 
									}
								})
							}else{
								console.log('这是不大于0')
							}
							this.youxiaoCount = res.data.count;
						} else if (res.code == -2) {
							// this.$Message.info('登陆超时，请重新登录');
							this.$router.push('/login')
						}
					})
				  
			},
			getCourseSpecialType() {
				
				
				getCourseDetail({
					cid: this.ncid
				}).then((res) => {
					if (res.code == 1) {
						 
						this.alllist=res.data.contents;
						 
						 
						// _this.changeVideo(_this.currentSpecial.video_list[0]);
					 
			 
					} 
				});
			},
			getData1() {
				 
				 
				this.alllist.forEach((item, index) => {
					 
					if (index === 0) {
						this.$set(item, "visible", true);
					} else {
						this.$set(item, "visible", false);
					}
					if (item.length > 0) {
						item.forEach((item1, index1) => {
							if (index1 === 0) {
								this.$set(item1, "visible", true);
							} else {
								this.$set(item1, "visible", false);
							}
							if (item1.video_list.length > 0) {
								item1.video_list.forEach((chapter, chapterIndex) => {
									let percent = 0;
									if (chapter.cont > chapter.totality) {
										percent = 100;
									} else if (chapter.totality > 0) {
										percent = parseInt(
											(chapter.cont / chapter.totality) * 100
										);
									}
									this.$set(chapter, "percent", percent);
								});
							} else {
								let percent = 0;
								if (item1.cont > item1.totality) {
									percent = 100;
								} else if (item1.totality > 0) {
									percent = parseInt(
										(item1.cont / item1.totality) * 100
									);
								}
								this.$set(item1, "percent", percent);
							}
						})
					}
				});
			},
			moveCarousel(direction) {
				// Find a more elegant way to express the :style. consider using props to make it truly generic
				if (direction === 1 && !this.atEndOfList) {
					this.currentOffset -= this.paginationFactor;
				} else if (direction === -1 && !this.atHeadOfList) {
					this.currentOffset += this.paginationFactor;
				}
			},
			handleClick(tab, event) {
				console.log(tab, event);
			},
			getData() {
				this.catalogList = this.subjectList;
				this.catalogList.forEach((item, index) => {
					if (index === 0) {
						this.$set(item, "visible", true);
					} else {
						this.$set(item, "visible", false);
					}

				});
			},
			
		},
		components: {
			Kclist,
			Kjlist
		},
	};
</script>
<style lang="less" scoped>
	.nkclist{
		padding:0 50px;margin:15px 0 5px
	}
	.VipRight {
		width: 1030px;
		float: right;
	}

	.QuickNavigation {
		background: #fff;
		margin-bottom: 20px;
	}

	.title-sub {
		font-size: 18px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #111;
		position: relative;
		padding: 20px 0;
		padding-left: 35px;
	}

	.title-sub:before {
		position: absolute;
		left: 26px;
		top: 25px;
		content: "";
		width: 3px;
		height: 21px;
		background: #3477ff;
	}

	.cone_left-title .title-sub {
		font-size: 20px;
	}

	.flex-align-items,
	.flex-items-justify-content {
		display: flex;
		align-items: center;
	}

	.QuickNavigation-list {
		text-align: center;
		cursor: pointer;
		margin: 0 25px;
	}

	.QuickNavigation-list .img {
		width: 45px;
		height: 45px;
		margin: 0 auto;
		display: block;
		margin-bottom: 10px;
		border-radius: 10px;
	}

	.right-content {
		padding: 20px;
		position: relative;
	}

	.QuickNavigation-list .title {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333;
		line-height: 24px;
		padding-bottom: 20px;
	}

	.card-carousel-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		// margin: 20px 0 40px;
		color: #666a73;
	}

	.card-carousel {
		display: flex;

		width: 100%;
	}

	.card-carousel--overflow-container {
		overflow: hidden;
	}

	.card-carousel--nav__left,
	.card-carousel--nav__right {
		display: inline-block;
		width: 15px;
		height: 15px;
		padding: 10px;
		box-sizing: border-box;
		border-top: 2px solid #42b883;
		border-right: 2px solid #42b883;
		cursor: pointer;
		margin: 0 10px;
		transition: transform 150ms linear;
	}

	.card-carousel--nav__left[disabled],
	.card-carousel--nav__right[disabled] {
		opacity: 0.2;
		border-color: black;
	}

	.card-carousel--nav__left {
		transform: rotate(-135deg);
	}

	.card-carousel--nav__left:active {
		transform: rotate(-135deg) scale(0.9);
	}

	.card-carousel--nav__right {
		transform: rotate(45deg);
	}

	.card-carousel--nav__right:active {
		transform: rotate(45deg) scale(0.9);
	}

	.card-carousel-cards {
		display: flex;
		transition: transform 150ms ease-out;
		transform: translatex(0px);
	}

	.card-carousel-cards .card-carousel--card {
		width: 220px;
		margin: 0 10px;
		cursor: pointer;
		// box-shadow: 0 4px 15px 0 rgb(124 125 128 / 6%), 0 2px 2px 0 rgb(40 44 53 / 8%);
		background-color: #fff;
		border-radius: 4px;
		z-index: 3;
		margin-bottom: 2px;
	}

	.card-carousel-cards .card-carousel--card:first-child {
		margin-left: 0;
	}

	.card-carousel-cards .card-carousel--card:last-child {
		margin-right: 0;
	}

	.card-carousel-cards .card-carousel--card--footer {
		border-top: 0;
		padding: 7px 15px;
		height: 68px;
	}

	.card-carousel-cards .card-carousel--card--footer p {
		padding: 15px 0;
		text-align: center;
		font-size: 19px;
		font-weight: 500;
		color: #fff;
		user-select: none;
	}

	.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2) {
		font-size: 12px;
		font-weight: 300;
		padding: 6px;
		background: rgba(40, 44, 53, 0.06);
		display: inline-block;
		position: relative;
		margin-left: 4px;
		color: #666a73;
	}

	.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):before {
		content: "";
		float: left;
		position: absolute;
		top: 0;
		left: -12px;
		width: 0;
		height: 0;
		border-color: transparent rgba(40, 44, 53, 0.06) transparent transparent;
		border-style: solid;
		border-width: 12px 12px 12px 0;
	}

	.card-carousel-cards .card-carousel--card--footer p:nth-of-type(2):after {
		content: "";
		position: absolute;
		top: 10px;
		left: -1px;
		float: left;
		width: 4px;
		height: 4px;
		border-radius: 2px;
		background: white;
		box-shadow: -0px -0px 0px #004977;
	}

	.bg_q {
		background: #71c8cf;
		    box-shadow: 4px 1px 8px 0 rgb(217 213 213 / 74%);
		border-radius: 4px;
		height: 80px;
	 
	}
	.tabBody{
		display: flex;
		    align-items: center;
		    justify-content: center;
		    color: #555;
		    font-size: 18px;
		    background: #fff;
		    flex-wrap: wrap;
		    padding: 0 24px;
	}
	.QuickNavigation .tabBody{
		width: 574px;
		    margin: 0 auto;
		    border-bottom: 1px solid #e6e6e6;
	 
	}
	.tabItem{
		margin: 15px 70px 0 70px;
		    padding-bottom: 18px;
		    cursor: pointer;
		    position: relative;
	}
	.tabActiveItem{
		color: #2d83f3;
		    font-weight: 700;
	}
	.cpage-tabitem-line{
		width: 100%;
		    height: 2px;
		    position: absolute;
		    bottom: 0;
		    right: 0;
		    background-color: #2d83f3;
	}
</style>
